export default __webpack_public_path__ + "static/media/Project-5.11a02e9d.jpg";